import { lazy } from 'react';

// Dynamic imports of all components.
const blocks = {
  'algolia-search':  lazy(() => import('Blocks/ProgramFinder/saf')),
  'program-selector':  lazy(() => import('Blocks/ProgramSelector/saf')),
  'algolia-global-search':  lazy(() => import('Blocks/GlobalSearch/saf')),
};

export default blocks;
